<div class="mx-3 my-3" *ngIf="episodeSelected$ | async; else noEpiodeSelected">
  <prp-properties-mazcard></prp-properties-mazcard>
</div>

<ng-template #noEpiodeSelected>
  <div class="d-flex justify-content-center align-items-center flex-column empty-search">
    <mat-icon class="large">play_circle_filled_white</mat-icon>
    <span>{{ 'list.noEpisodeSelected' | translate }}</span>
  </div>
</ng-template>
